// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

// Dynamic environment detection
const getEnvironment = () => {
  if (typeof window === "undefined") return "production"; // SSR fallback

  const hostname = window.location.hostname;

  // Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "development";
  }

  // Dev branches (subdomains of dev.dm2buy.com)
  if (hostname.includes("dev.dm2buy.com")) {
    return "development";
  }

  // Production
  return "production";
};

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 0,
  debug: false,
  environment: getEnvironment(), // Dynamic environment

  beforeSend(event) {
    if (event.exception) {
      const error = event.exception.values[0];
      if (error && error.value) {
        if (error.value.includes("ResizeObserver loop completed with undelivered notifications")) {
          console.log("🚫 CLIENT - Filtering out ResizeObserver error");
          return null;
        }
      }
    }

    return event;
  },
});
